import { PostFieldsFragment } from '@/src/generated/graphql';
import { renderToStaticMarkup } from 'react-dom/server';
import { RelatedPostsInBody, PostItem } from '@components';

const genAnchor = (i: number) => `<!-- 関連リンク${i} -->`;

type RelatedPosts =
  | PostFieldsFragment['hnaviRelatedPosts1']
  | PostFieldsFragment['hnaviRelatedPosts2'];

type PostData = {
  [href: string]:
    | {
        title: string | null | undefined;
        featuredImageUrl: string | null | undefined;
      }
    | undefined;
};

const toPostItems = ({
  relatedPosts: pp,
  postData,
}: {
  relatedPosts: NonNullable<RelatedPosts>;
  postData: PostData;
}): PostItem[] =>
  [
    {
      href: pp.href1,
      imgSrc:
        postData[pp.href1 || '']?.featuredImageUrl || pp.image1?.sourceUrl,
      label: postData[pp.href1 || '']?.title || pp.label1,
    },
    {
      href: pp.href2,
      imgSrc:
        postData[pp.href2 || '']?.featuredImageUrl || pp.image2?.sourceUrl,
      label: postData[pp.href2 || '']?.title || pp.label2,
    },
    {
      href: pp.href3,
      imgSrc:
        postData[pp.href3 || '']?.featuredImageUrl || pp.image3?.sourceUrl,
      label: postData[pp.href3 || '']?.title || pp.label3,
    },
  ].filter((e): e is PostItem => !!(e.imgSrc && e.href && e.label));

const insertRelatedPosts = ({
  src,
  relatedPosts,
  anchor,
  postData,
}: {
  src: string;
  relatedPosts: RelatedPosts;
  anchor: string;
  postData: PostData;
}) => {
  if (!relatedPosts) {
    return src;
  }
  const postItems = toPostItems({ relatedPosts, postData });
  if (postItems.length === 0) {
    return src;
  }
  return src.replace(
    anchor,
    renderToStaticMarkup(
      <RelatedPostsInBody
        postItems={postItems}
        heading={relatedPosts.heading}
        bgColor={relatedPosts.bgColor}
      />
    ) + anchor
  );
};

export const insertAllRelatedPosts = ({
  src,
  relatedPostsList,
  postData,
}: {
  src: string;
  relatedPostsList: RelatedPosts[];
  postData: PostData;
}) =>
  relatedPostsList.reduce(
    (acc, cur, i) =>
      insertRelatedPosts({
        src: acc,
        relatedPosts: cur,
        anchor: genAnchor(i + 1),
        postData,
      }),
    src
  );
